import { inject, Injectable } from '@angular/core';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';
import { Store } from '@ngxs/store';
import { WorkAppDevicesV2Service, WorkCreateAppDeviceDto, WorkCreatePushNotificationTokenDto } from '@work-frontend-monorepo/work-rest-api';
import { ProfileStateSetAppDeviceId } from '@work-frontend-monorepo/work-ui/state-management';

@Injectable({
  providedIn: 'root',
})
export class AppDeviceService {
  private workAppDevicesV2Service = inject(WorkAppDevicesV2Service);
  private store = inject(Store);

  /**
   * Initialize app device information and send to API. Either with or without
   * push notification token.
   *
   * @param pushNotificationToken
   */
  public async initializeAppDeviceInformation(pushNotificationToken: string = '') {
    let appInfo = { version: '1.0.0' };
    if (Capacitor.isNativePlatform()) {
      appInfo = await App.getInfo();
    }
    const deviceId = await Device.getId();
    const deviceInfo = await Device.getInfo();
    const createPushNotificationTokenDto: WorkCreatePushNotificationTokenDto = {
      token: pushNotificationToken,
    };
    const dto: WorkCreateAppDeviceDto = {
      model: deviceInfo.model,
      osVersion: deviceInfo.osVersion,
      platform: deviceInfo.platform,
      uniqueIdentifier: deviceId.identifier,
      appVersion: appInfo.version,
      pushNotificationDto: pushNotificationToken ? createPushNotificationTokenDto : undefined,
    };
    this.workAppDevicesV2Service
      .appDevicesV2ControllerRegisterOrUpdate({
        body: dto,
      })
      .subscribe({
        next: (appDevice) => {
          if (appDevice && appDevice.appDeviceId) {
            this.store.dispatch(new ProfileStateSetAppDeviceId(appDevice.appDeviceId));
          }
        },
      });
  }
}
